import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface VideoSetupState {
  name: string | null;
  ttl: number;
  countries: string[];
  duration?: number;
}

export const videoSetupInitialState: VideoSetupState = {
  name: null,
  ttl: 86400, // 1 день
  countries: [],
};

export const videoSetupSlice = createSlice({
  name: 'videoSetup',
  initialState: videoSetupInitialState,
  reducers: {
    setSetup: (state, action: PayloadAction<VideoSetupState>) => {
      return action.payload;
    },

    setTTL(state, action: PayloadAction<number>) {
      state.ttl = action.payload;
    },

    setCountries(state, action: PayloadAction<string[]>) {
      state.countries = action.payload;
    },

    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
  },
});

export const videoSetupReducer = videoSetupSlice.reducer;

export const { setTTL, setCountries, setSetup, setName } = videoSetupSlice.actions;
